export default __webpack_public_path__ + "static/media/emptyProfileIcon.ee73765c.svg";